// Genera una clave de idempotencia para evitar duplicados en reintentos (usa UUID cuando está disponible).
export const generateIdempotencyKey = (prefix = 'idemp'): string => {
  if (typeof crypto !== 'undefined' && typeof crypto.randomUUID === 'function') {
    return crypto.randomUUID();
  }
  return `${prefix}_${Date.now()}_${Math.random().toString(16).slice(2)}`;
};

export const buildScopedIdempotencyKey = (
  baseKey: string,
  ...segments: Array<string | number | null | undefined>
): string =>
  [baseKey, ...segments]
    .filter((segment) => segment !== null && segment !== undefined && String(segment).trim() !== '')
    .map((segment) => String(segment).trim())
    .join(':')
    .slice(0, 100);

export type OrderPartCommandAction = 'reserve' | 'consume' | 'release';

// Los comandos por línea usan una clave estable para conservar deduplicación entre reintentos o doble clic.
export const buildOrderPartCommandIdempotencyKey = (
  action: OrderPartCommandAction,
  orderId: number | string,
  partId: number | string,
): string => `ui:orders:parts:${action}:o${String(orderId)}:l${String(partId)}`;
